import { MODULE_NAME, LOGOS } from './logos-mutation-types';
import HistoryBaseRoute from '@/classes/history-route-class';

const routeName = `${MODULE_NAME}-${LOGOS}`;
const routePath = `/${MODULE_NAME}`;
const baseHistory = '/logos/history';
const History = new HistoryBaseRoute({ path: baseHistory });

export default [
	{
		name: `${MODULE_NAME}-edit`,
		path: `${routePath}/edit/:id(\\d+)`,
		props: route => ({
			id: parseInt(route.params.id)
		}),
		component: () =>
			import(
				/* webpackChunkName: "viewReport" */ '@/sections/logos/summary/logos.vue'
			),
		meta: {
			permissions: ['logos.create', 'logos.update']
		}
	},
	History.routeRedirect(),
	History.routeRedirect('/logos/history/:id/:name'),
	{
		name: 'logos-history',
		path: History.path(),
		props: route => History.parseParams(route.params),
		component: () =>
			import(
				/* webpackChunkName: "viewReport" */ '@/sections/logos/history/'
			),
		meta: {
			permissions: ['logos.read']
		}
	},
	{
		name: routeName,
		path: `${routePath}/(search-):search?`,
		props: route => ({
			search: route.params.search || ''
		}),
		component: () =>
			import(
				/* webpackChunkName: "viewReport" */ '@/sections/logos/summary/logos.vue'
			),
		meta: {
			permissions: ['logos.read']
		}
	}
];
